import React from 'react';

export const ManagingPartnerSection = () => (
  <section
    aria-labelledby="managing-partner-name"
    data-testid="managing-partner-section"
    className="py-16 sm:py-20 bg-gray-50 border-t border-gray-200"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
        <figure className="min-w-0">
          <img
            src="/images/amar-reddy.jpeg"
            alt="Amar Reddy, Managing Partner at SAMANVAI"
            width={450}
            height={318}
            loading="lazy"
            data-testid="managing-partner-photo"
            className="rounded-2xl shadow-xl w-full max-w-md h-auto object-contain mx-auto"
          />
          <figcaption className="mt-6 text-center">
            <p data-testid="managing-partner-photo-name" className="text-xl font-bold text-gray-900">Amar Reddy</p>
            <p data-testid="managing-partner-photo-role" className="text-emerald-600 font-medium">Managing Partner</p>
          </figcaption>
        </figure>

        <div className="min-w-0">
          <p data-testid="managing-partner-role" className="text-emerald-600 font-medium mb-2">Managing Partner</p>
          <h2 id="managing-partner-name" data-testid="managing-partner-name" className="text-base md:text-lg font-bold text-gray-900 mb-3">
            Amar Reddy
          </h2>
          <p data-testid="managing-partner-specialty" className="text-base md:text-lg font-semibold text-gray-900 mb-8">
            Marketing, Business Development &amp; Enterprise Alliances
          </p>
          <div data-testid="managing-partner-biography" className="space-y-6 text-base md:text-lg text-gray-600 leading-relaxed">
            <p data-testid="managing-partner-biography-experience">
              Amar Reddy brings over two decades of enterprise business development, marketing, and channel leadership to SAMANVAI. He specializes in go-to-market strategy for AI-driven platforms, enterprise account acquisition, and translating complex technology into board-level dialogue.
            </p>
            <p data-testid="managing-partner-biography-expertise">
              His expertise spans MSP and vendor-channel management, strategic account planning, partnership development, and end-to-end client acquisition — from market positioning and outreach to MSA negotiation and long-term account growth. He has worked across federal, Fortune 500, and Tier-1 partner ecosystems, giving him a practical read on how enterprises evaluate and adopt emerging technology.
            </p>
            <p data-testid="managing-partner-biography-responsibilities">
              Certified in Generative AI applications and holding an Executive MBA certification from the Katz School of Business, University of Pittsburgh, Amar pairs commercial discipline with applied AI fluency. At SAMANVAI, he leads marketing strategy, enterprise business development, and alliance building, positioning the platform for the CXO and transformation leaders it serves across the US and India.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);